export const SSO_KEY = {
    SET_STORE_OTP_CODE: "auth/setOtpCode",
    GET_STORE_OTP_CODE: "auth/getOtpCode",
    COOKIE_OTP_CODE: "jumper"
};
